(function () {
  function initNfpHero(hero) {
    if (!hero || hero.dataset.nfpHeroReady === 'true') return;

    var slides = hero.querySelectorAll('.nfp-hero__slide');
    var dots = hero.querySelectorAll('.nfp-hero__dot');
    var prev = hero.querySelector('.nfp-hero__arrow--prev');
    var next = hero.querySelector('.nfp-hero__arrow--next');

    if (!slides.length) return;

    hero.dataset.nfpHeroReady = 'true';
    hero.setAttribute('tabindex', '0');

    var current = 0;
    var timer = null;
    var autoplay = hero.dataset.autoplay === 'true';
    var speed = parseInt(hero.dataset.speed, 10) || 6000;
    var startX = 0;
    var endX = 0;
    var swipeThreshold = 45;

    function showSlide(index) {
      if (index < 0) index = slides.length - 1;
      if (index >= slides.length) index = 0;

      slides[current].classList.remove('is-active');
      if (dots[current]) dots[current].classList.remove('is-active');

      current = index;

      slides[current].classList.add('is-active');
      if (dots[current]) dots[current].classList.add('is-active');
    }

    function nextSlide() {
      showSlide(current + 1);
    }

    function prevSlide() {
      showSlide(current - 1);
    }

    function stopAutoplay() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }

    function startAutoplay() {
      if (!autoplay || slides.length <= 1) return;
      stopAutoplay();
      timer = setInterval(nextSlide, speed);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        prevSlide();
        startAutoplay();
      });
    }

    if (next) {
      next.addEventListener('click', function () {
        nextSlide();
        startAutoplay();
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        var index = parseInt(dot.dataset.dotIndex, 10);
        if (!isNaN(index)) {
          showSlide(index);
          startAutoplay();
        }
      });
    });

    hero.addEventListener('mouseenter', stopAutoplay);
    hero.addEventListener('mouseleave', startAutoplay);

    hero.addEventListener('keydown', function (event) {
      if (event.key === 'ArrowLeft') {
        prevSlide();
        startAutoplay();
      }

      if (event.key === 'ArrowRight') {
        nextSlide();
        startAutoplay();
      }
    });

    hero.addEventListener('touchstart', function (event) {
      if (!event.touches || !event.touches.length) return;
      startX = event.touches[0].clientX;
      stopAutoplay();
    }, { passive: true });

    hero.addEventListener('touchmove', function (event) {
      if (!event.touches || !event.touches.length) return;
      endX = event.touches[0].clientX;
    }, { passive: true });

    hero.addEventListener('touchend', function () {
      var distance = startX - endX;

      if (Math.abs(distance) > swipeThreshold) {
        if (distance > 0) {
          nextSlide();
        } else {
          prevSlide();
        }
      }

      startAutoplay();
      startX = 0;
      endX = 0;
    });

    startAutoplay();
  }

  function initAllHeroes() {
    document.querySelectorAll('.nfp-hero').forEach(initNfpHero);
  }

  document.addEventListener('DOMContentLoaded', initAllHeroes);
  document.addEventListener('shopify:section:load', function (event) {
    if (event.target) {
      event.target.querySelectorAll('.nfp-hero').forEach(function (hero) {
        hero.dataset.nfpHeroReady = 'false';
        initNfpHero(hero);
      });
    }
  });
})();